import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
  Paper,
  TableContainer,
} from "@mui/material";
import { styled } from "@mui/system";
import { useParams } from "react-router-dom";
import PaginationComponent from "components/ui-components/PaginationComponent";
import moment from "moment";
import { useGetListAllVendorsQuery } from "store/slices/apis/VendorDashboardSlice";
import { useGetMatrixDataQuery } from "store/slices/apis/VendorDashboardSlice";


const StyledTableHead = styled(TableCell)({
  fontWeight: 500,
  fontSize: "14px",
  color: "#505258",
  padding: "10px 14px",
  backgroundColor: "#F8F8F8",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  letterSpacing: "-0.2px"
});


const StyledTableBody = styled(TableCell)({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#FFFFFF",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  letterSpacing: "-0.2px"
});



const VendorListData = () => {
  const theme = useTheme();
  const { projectId } = useParams();



  const { data, isLoading, error } = useGetListAllVendorsQuery({ projectId })



  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const totalPages = data ? Math.ceil(data.length / rowsPerPage) : 1;





  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = data ? data.slice(startIndex, endIndex) : [];

  return (
    <>
      <Box sx={{ width: "100%", border: "1px solid #D8D8D8", borderRadius: "12px", overflow: "hidden", height: "424px" }}>
        <Box sx={{ backgroundColor: "#fff", p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "18px", color: `${theme?.customSettings?.themeColor}`, letterSpacing: "-0.4px", lineHeight: "100%" }}>
            List of all Vendors
          </Typography>
          <Typography sx={{ mb: 1, mt: '5px', color: "#182A4E80", letterSpacing: "-0.4px", lineHeight: "100%" }}>
            Track vendor performance against planned timelines to manage delays and ensure accountability
          </Typography>
        </Box>
        <Paper sx={{ boxShadow: "none" }}>
          <TableContainer>
            <Table sx={{ width: "100%", border: "1px solid #D8D8D8" }}>
              <TableHead>
                <TableRow>
                  {[
                    "Sl number",
                    "Vendor name",
                    "Vendor Type",
                    "Otd Rating",
                    "Quality Rating",
                    "Response Time Rating",
                    "Cost Rating",
                    "Safety Rating",
                    "Schedule Rating",
                    "Issues Rating",
                    "Overall Rating"
                  ].map((header) => (
                    <StyledTableHead key={header}>{header}</StyledTableHead>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentRows.length > 0 ? (
                  currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <StyledTableBody>{startIndex + index + 1}</StyledTableBody>
                      <StyledTableBody>{row.vendorName || "-"}</StyledTableBody>
                      <StyledTableBody>{row.vendorType || "-"}</StyledTableBody>
                      <StyledTableBody>{row.otdRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.qualityRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.responseTimeRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.constRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.safetyRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.scheduleRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.issuesRating || "-"}</StyledTableBody>
                      <StyledTableBody>{row.overallRating || "-"}</StyledTableBody>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <StyledTableBody colSpan={8} align="center">
                      No data available
                    </StyledTableBody>
                  </TableRow>
                )}

              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Box sx={{ display: "flex", justifyContent: "flex-end", backgroundColor: "#fff", p: 2 }}>
          {/* {!isLoading && ( */}
          <PaginationComponent
            pageNumber={currentPage}
            totalPages={totalPages || 1}
            onPageChange={setCurrentPage}
          />
          {/* )} */}
        </Box>

      </Box>
    </>
  );
};

export default VendorListData;



